import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildBrandLogoEntity } from "@youm-front/brand/utils/factory";
import { ROOM_BRAND_LOGO_FEATURE_KEY, RoomBrandLogoState } from "../reducers";

const roomBrandLogoState = createFeatureSelector<RoomBrandLogoState>(
  ROOM_BRAND_LOGO_FEATURE_KEY
);

export const brandLogo = createSelector(
  roomBrandLogoState,
  (state: RoomBrandLogoState) =>
    state.brandLogo ? buildBrandLogoEntity(state.brandLogo) : null
);

export const isLoading = createSelector(
  roomBrandLogoState,
  (state: RoomBrandLogoState) => state.isLoading
);
